module.exports = __webpack_public_path__ + "img/coupon_tutorial_bepiu01.ddc2a143.png";